import { render, staticRenderFns } from "./KnGroupAddStudent.vue?vue&type=template&id=1bdbc31c&scoped=true"
import script from "./KnGroupAddStudent.js?vue&type=script&lang=js&external"
export * from "./KnGroupAddStudent.js?vue&type=script&lang=js&external"
import style0 from "./KnGroupAddStudent.vue?vue&type=style&index=0&id=1bdbc31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdbc31c",
  null
  
)

export default component.exports